import { BrandRouteResolver } from '@/util/brandRouteResolver'
import { InstanceResolver } from '@/util/instanceResolver'
import * as queryString from 'querystring'

export interface InvalidPriceItem {
  skuId: string
  itemName: string
  formattedBeforePrice: string
  formattedAfterPrice: string
}

export enum HavingPreSalesItemsState {
  All,
  Included,
  None,
}

/**
 * カート画面へアクセスする時に付与すると、動作に影響するクエリ
 * @note
 * {@see queryString.stringify}経由で構築するケースがあるが、
 * 型定義上key-valueとしても定義されていないと型エラー扱いになる（at TypeScript v3.5.3）.
 * key-valueとしての定義を省いても型エラーにならなければ、key-value部分は削除しても良い.
 */
export type CartPageQuery = {
  /**
   * "true" の時、新たにカート追加されたことを伝えるメッセージをカート画面に表示する
   */
  readonly isCartIn?: 'true'
} & {
  [key: string]: unknown
}

interface CartPageUrlOption {
  readonly origin: string
}
export class CartPageURL {
  public static forBrand(brand: string, query: CartPageQuery = {}, opt: CartPageUrlOption = location): URL {
    return InstanceResolver.isMulti()
      ? new URL(
          BrandRouteResolver.makeResourceEndpoint({
            brand,
            path: ['cart'],
            query,
            withSpaPrefix: true,
          }),
          opt.origin
        )
      : this.buildPath(this.cartPagePathOnSingleInstance, query, opt)
  }

  private static readonly cartPagePathOnSingleInstance = '/s/cart'

  private static buildPath(path: string, query: CartPageQuery, opt: CartPageUrlOption): URL {
    const url = new URL(path, opt.origin)
    url.search = queryString.stringify(query)

    return url
  }

  protected constructor() { /* nothing to do */ }
}
